import request from '@/router/axios';
let urlPrefix = '/api/shenbao/shenbaoexp2user'

// /shenbaoexp2user/{labExp2UserUid}/info 获取用户的申报项目实验记录
export const getRecordByUid = labExp2UserUid => {
    return request(`${urlPrefix}/${labExp2UserUid}/info`)
}

// /shenbaoexp2user/{shenbaoExpId}/users/result 老师获取申报实验的学生成绩列表
export const getRecordByShenbaoExpId = (shenbaoExpId,page,limit,params) => {
    return request(`${urlPrefix}/${shenbaoExpId}/users/result`,{
        params: {
            ...params,
            page,
            limit
        }
    })
}